<template>
  <div class="card">
    <div class="card-content">
      <question-title :question="question" class="mb1"></question-title>

      <div class="control mt1">
        <input
          class="input"
          type="email"
          placeholder="Email"
          :value="choice"
          @input="recordAnswer"
        />
      </div>

      <next-button :id="question.id" :choice="choice"></next-button>
    </div>
  </div>
</template>

<script>
import emailValidator from "email-validator";
import baseQuestion from "./baseQuestion";

export default {
  name: "email",

  mixins: [baseQuestion],

  methods: {
    recordAnswer(e) {
      const email = e.target.value;
      const valid = emailValidator.validate(email);

      if (valid) {
        this.choice = email;
        this.$store.dispatch("interview/setNext", true);
      } else if (!valid) {
        this.$store.dispatch("interview/setNext", false);
      }
    }
  }
};
</script>
